import { API } from "aws-amplify";
import { getResourceUpdateAccessRight } from "~/graphql/queries";
import { LoaderData } from "~/types";
import * as APITypes from "~/API";
import { ResourceAccessLRUCache } from "~/services/cache/lruCache/authAccess";

export const EMPTY_RESOURCE_UPDATE_ACCESS_RIGHT_INFO: APITypes.ResourceUpdateAccessRight =
  {
    __typename: "ResourceUpdateAccessRight",
    id: "",
    resourceType: APITypes.EntityType.Property,
    resourceID: "",
    userID: null,
    ownerID: null,
    ownerType: null,
    readAccessStatus: APITypes.ResourceAccessRightStatus.NotGranted,
    readAccessApproverID: "",
    readAccessApprovalDate: "",
    writeAccessStatus: APITypes.ResourceAccessRightStatus.NotGranted,
    writeAccessApproverID: "",
    writeAccessApprovalDate: "",
    createdAt: "",
    updatedAt: "",
    _version: 0,
    _lastChangedAt: 0,
  };

export const getResourceAccess = async ({
  userID,
  resourceID,
  forceReload = false,
}: {
  userID?: string;
  resourceID?: string;
  forceReload?: boolean;
}): Promise<LoaderData<APITypes.ResourceUpdateAccessRight>> => {
  const cacheKey = `${userID}-${resourceID}`;

  // Try to get from cache if not forcing reload
  if (!forceReload) {
    const cachedResponse = ResourceAccessLRUCache.get(cacheKey);
    if (cachedResponse.success) {
      return cachedResponse.data;
    }
  }

  try {
    const id = `${userID}-${resourceID}`;
    const response = (await API.graphql({
      query: getResourceUpdateAccessRight,
      variables: {
        id,
      },
    })) as { data?: APITypes.GetResourceUpdateAccessRightQuery };

    const result = {
      success: true,
      data:
        response.data?.getResourceUpdateAccessRight ||
        EMPTY_RESOURCE_UPDATE_ACCESS_RIGHT_INFO,
    };

    // Update cache with the fetched data
    ResourceAccessLRUCache.update({
      key: cacheKey,
      value: result,
    });

    return result;
  } catch (error) {
    return {
      success: false,
      data: EMPTY_RESOURCE_UPDATE_ACCESS_RIGHT_INFO,
      error,
    };
  }
};
